var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"providers wrapper"},_vm._l((_vm.providerData),function(rate){return _c('provider',{key:rate.name,attrs:{"rates":rate[_vm.region]},on:{"total":function($event){_vm.collectValues($event)}}})}))}
var staticRenderFns = []

export { render, staticRenderFns }